import React from "react";
import merchantlogo from "../../assets/images/paymentgateway.png";
import { ReactComponent as Paylogo } from "../../assets/images/pay-logo.svg";
import styles from "./Checkouthome.module.scss";
import { useSelector } from "react-redux";
import queryString from "query-string";
import { commarize } from "../../utils/helpers";
import PoweredBy from "../../components/PoweredBy/PoweredBy";

const MerchantDetail = () => {
  const body = queryString.parse(window.location.search);

  const { orderDetails } = useSelector((state) => state.orderDetailsReducer);
  const orderfee = useSelector((state) => state.orderFeeReducer);
  const fee: number = orderfee?.data?.customerFee ?? 0;
  const merchantLogo = orderDetails?.data?.subsidiary?.customization[0];
  const merchantName = orderDetails?.data?.subsidiary?.name;
  const currency = orderDetails?.data?.order?.currency;
  const amount = orderDetails?.data?.order?.amount;
  console.log({ orderDetails });
  return (
    <div className={styles.paymentCheckoutHeader}>
      <div className={styles.paymentSummary}>
        <div className={styles.companyLogo}>
          <img
            src={merchantLogo?.value ?? merchantlogo}
            alt={merchantLogo?.key ?? "logo"}
          />
        </div>
        <div className={styles.otherPaymentSummary}>
          <div className={styles.merchantName}>
            <p>{merchantName}</p>
          </div>
          <div className={styles.PaymentAmountWrapper}>
            <p className={styles.PaymentAmount}>
              <Paylogo /> {currency ?? "NGN"}
              {commarize(
                body?.amount != null
                  ? Number(body.amount) + (fee)
                  : Number(amount) + (fee)
              )}
            </p>
            <p className={styles.CustomerEmail}>{body.email}</p>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default MerchantDetail;
